import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { ComparableWidget } from "./models/Widget";
import {Geometry} from "ol/geom";
import { Profile } from "./models/ComputingServer";

export default class OldWidgetVuexModule extends AbacoVuexModule {
    @State({default: {}}) comparableWidgets!: Record<string, ComparableWidget>
    @State() hilitePoint!: Profile | null; 
    @State() drawnGeometry!: Geometry | null;
}
